import moment from 'moment-timezone';
import BravelyData from './data';
import { log } from './log';

let timeZone = BravelyData('timeZone', moment.tz.guess());

export const setTimeZone = (newTimeZone) => {
  log('[BravelyTimeZone] Current:', newTimeZone, 'Previous:', timeZone);
  return (timeZone = newTimeZone);
};

export default () => timeZone;
